/**
 * Nagłówek karty klienta – badge'e (Top, Aktywny) oraz pola Opiekun, Oddział, Segment
 */

import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { Pencil } from 'react-bootstrap-icons';
import { Skeleton, Button } from '@mui/material';

import type { IResponse as IClientResponse } from 'api/endpoints/useGetClient';
import { Link } from 'components/controls';
import { WiseBadge } from 'components/wise';

import styles from 'theme/components/containers/TraderClientCardContainer/TraderClientDataHeader/TraderClientDataHeader.module.scss';

interface ITraderClientDataHeaderProps {
  client?: IClientResponse | null;
  isLoading?: boolean;
}

const isClientActive = (client: IClientResponse | null | undefined): boolean => {
  if (!client) return false;

  return client.is_active;
};

const isClientTop = (client: IClientResponse | null | undefined): boolean => {
  if (!client) return false;

  return client.is_top;
};

const TraderClientDataHeader: FC<ITraderClientDataHeaderProps> = ({ client, isLoading = false }) => {
  const { t } = useTranslation();
  const showActiveBadge = isClientActive(client);
  const showTopBadge = isClientTop(client);

  if (isLoading) {
    return (
      <div
        className={classnames(
          styles.clientDataHeader,
          'StylePath-Containers-TraderClientCardContainer-TraderClientDataHeader'
        )}>
        <div className={styles.topRow}>
          <div className={styles.badgesRow}>
            <Skeleton variant="rounded" width={64} height={24} />
            <Skeleton variant="rounded" width={80} height={24} />
          </div>
          <Skeleton variant="rounded" width={120} height={36} />
        </div>
        <div className={styles.itemsRow}>
          <Skeleton variant="text" width={120} height={20} />
          <Skeleton variant="text" width={100} height={20} />
          <Skeleton variant="text" width={90} height={20} />
        </div>
      </div>
    );
  }

  const editPath = client ? `/trader/clients/${client.id}/edit` : '#';

  return (
    <div
      className={classnames(
        styles.clientDataHeader,
        'StylePath-Containers-TraderClientCardContainer-TraderClientDataHeader'
      )}>
      <div className={styles.topRow}>
        <div className={styles.badgesRow}>
          {showTopBadge && <WiseBadge variant="favourite" size="small" />}
          {showActiveBadge && <WiseBadge variant="active" size="small" />}
        </div>
        <Button
          color="secondary"
          component={Link}
          to={editPath}
          variant="outlined"
          size="small"
          startIcon={<Pencil />}>
          {t('Edytuj klienta')}
        </Button>
      </div>
      {/*<div className={styles.itemsRow}>*/}
      {/*  <div className={styles.clientDataHeaderItem}>*/}
      {/*    <span className={styles.clientDataHeaderLabel}>{t('Opiekun')}:</span>*/}
      {/*    <span className={styles.clientDataHeaderValue}>Placeholder</span>*/}
      {/*  </div>*/}
      {/*  <div className={styles.clientDataHeaderItem}>*/}
      {/*    <span className={styles.clientDataHeaderLabel}>{t('Oddział')}:</span>*/}
      {/*    <span className={styles.clientDataHeaderValue}>Placeholder</span>*/}
      {/*  </div>*/}
      {/*  <div className={styles.clientDataHeaderItem}>*/}
      {/*    <span className={styles.clientDataHeaderLabel}>{t('Segment')}:</span>*/}
      {/*    <span className={styles.clientDataHeaderValue}>Placeholder</span>*/}
      {/*  </div>*/}
      {/*</div>*/}
    </div>
  );
};

export default TraderClientDataHeader;
